import Vue from 'vue';
import Loading from '@/components/cardloading.vue';
import Loading1 from '@/components/cardloading2.vue'

const LoadingConstructor = Vue.extend(Loading);
const LoadingConstructor1 = Vue.extend(Loading1);

const loadingPlugin = {
  install(Vue) {
    const instance = new LoadingConstructor({ //第一个 ，  
      el: document.createElement('div')
    });
    const instance1 = new LoadingConstructor1({//第二个
      el: document.createElement('div')
    });

    document.body.appendChild(instance.$el);//第一个
    document.body.appendChild(instance1.$el);//第二个

    Vue.prototype.$cardloading = {
      cardloading: (bool, text) => {
        instance.cardloading(bool, text);
      },
      cardloading1: (bool, text) => {
        instance1.cardloading1(bool, text);
      },
    };

  }
};

export default loadingPlugin;